export default __webpack_public_path__ + "static/media/target.3068e502.svg";